export default function About() {
  return (
    <section className="py-20 bg-gradient-to-b from-white to-blue-50/30">
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Sobre PaisaNet
          </h2>
          <div className="w-24 h-1 bg-blue-600 mx-auto rounded-full"></div>
        </div>

        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div className="space-y-6">
            <p className="text-lg text-gray-700 leading-relaxed">
              PaisaNet es un servicio creado para ayudar a la comunidad latina en Kentucky con trámites administrativos y oportunidades para emprender.
            </p>
            <p className="text-lg text-gray-700 leading-relaxed">
              Sabemos que muchos procesos en Estados Unidos pueden ser complicados si no conoces el sistema. Por eso ayudamos a nuestros clientes a abrir empresas, obtener su EIN, registrar vehículos, gestionar placas y acceder a soluciones de crédito para negocios.
            </p>
            <p className="text-lg text-gray-700 leading-relaxed">
              Nuestro objetivo es ayudar a más latinos a crecer, formalizar sus negocios y construir un mejor futuro para sus familias.
            </p>
          </div>

          <div className="relative">
            <div className="w-full h-96 rounded-lg overflow-hidden shadow-2xl">
              <img
                src="https://public.readdy.ai/ai/img_res/83c61c23f8a1fb4bb4842dd26c909d28.jpg"
                alt="Comunidad PaisaNet"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="absolute -bottom-6 -right-6 w-32 h-32 bg-blue-600 rounded-lg opacity-20 -z-10"></div>
            <div className="absolute -top-6 -left-6 w-32 h-32 bg-green-500 rounded-lg opacity-20 -z-10"></div>
          </div>
        </div>
      </div>
    </section>
  );
}